var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"anni-page-not-found"},[_c('h1',[_vm._v("Seite nicht gefunden")]),_c('p',[_vm._v("Die von Ihnen angeforderte Seite konnte leider nicht gefunden werden.")]),_c('a',{staticClass:"go-to-home-btn",attrs:{"href":"/"}},[_vm._v(" Zurück zur Startseite ")])])
}]

export { render, staticRenderFns }